// Tracks how long the visitor dwells on topical zones (elements tagged with
// data-topic="kitchen|bathroom|wholehome"). Used to give the AI concierge a
// context-aware greeting. Falls back to shuffled general greetings.

const dwell = { kitchen: 0, bathroom: 0, wholehome: 0 };

export function initDwellTracking() {
  if (typeof window === "undefined") return () => {};
  const visible = new Map(); // topic -> ratio

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        const topic = e.target.getAttribute("data-topic");
        if (!topic) return;
        if (e.isIntersecting && e.intersectionRatio >= 0.4) {
          visible.set(topic, e.intersectionRatio);
        } else {
          visible.delete(topic);
        }
      });
    },
    { threshold: [0, 0.4, 0.75, 1] }
  );

  document.querySelectorAll("[data-topic]").forEach((el) => io.observe(el));

  const id = setInterval(() => {
    // only credit dwell time while the tab is focused
    if (document.hidden) return;
    visible.forEach((_, topic) => {
      if (dwell[topic] != null) dwell[topic] += 0.4;
    });
  }, 400);

  return () => {
    clearInterval(id);
    io.disconnect();
  };
}

// Returns the topic with the most dwell time above a minimum threshold, else null.
export function topDwellTopic(minSeconds = 2.5) {
  const entries = Object.entries(dwell).sort((a, b) => b[1] - a[1]);
  const [topic, time] = entries[0] || [null, 0];
  return topic && time >= minSeconds ? topic : null;
}
